/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Table } from "@nordcloud/gnui";
import { Item } from "~/types";
import {
  SidebarItem as DefaultSidebarItem,
  SidebarItemType,
} from "./SidebarItem";

type Props = {
  items: readonly Item[];
  showValueInOptions?: boolean;
  onSelect: (i: string) => void;
  selectedOptions?: string[];
  disabledOptions: { id: string; state: boolean }[];
  sidebarItem?: SidebarItemType;
};

export function SidebarItemList({
  items,
  onSelect,
  showValueInOptions,
  selectedOptions,
  disabledOptions,
  sidebarItem: SidebarItem = DefaultSidebarItem,
}: Props) {
  return (
    <>
      <Table.tbody>
        {items.map((item: Item) => (
          <SidebarItem
            key={item.id}
            item={item}
            onSelect={() => onSelect(item?.id ?? "")}
            {...{ showValueInOptions, selectedOptions, disabledOptions }}
          />
        ))}
      </Table.tbody>
    </>
  );
}
